import { connect } from 'react-redux'

import ThankYou from './ThankYou'
import { getFromSettings, isAfterHours } from 'src/utils/helpers'

const mapStateToProps = state => {
  const afterHours = getFromSettings(state, 'afterHours')
  const timeZone = parseFloat(getFromSettings(state, 'timeZone', 0))
  const countryIsoCode = getFromSettings(state, 'countryIsoCode')

  return {
    isAfterHours: isAfterHours(afterHours, timeZone),
    awayMessage: afterHours.awayMessage,
    countryIsoCode: countryIsoCode,
  }
}

export default connect(mapStateToProps)(ThankYou)
